var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Grid } from 'syf-component-library/ui/patterns';
import { Inset } from 'syf-component-library/ui/spacing';
import { HeaderContainer, HeaderContent, HeaderWrapper, Image, SubTitle, Title } from './subcomponents';
import { translate } from '../../../strings/i18n';
import getImages from '../../../modal/content/helpers/get-images';
import { useManageCardHolderContext } from '../../../context';
var ManageCardholdersHeader = function (_a) {
    var usersLimit = _a.usersLimit;
    var config = useManageCardHolderContext().config;
    var addAuthorizedUser = getImages({ config: config }).addAuthorizedUser;
    return (_jsx(HeaderWrapper, __assign({ all: "large", "data-testid": "manage-cardholders-header" }, { children: _jsx(Grid, __assign({ wrap: "nowrap" }, { children: _jsxs(HeaderContainer, { children: [_jsx(Image, { src: addAuthorizedUser, alt: "manage-cardholders-image" }), _jsxs(HeaderContent, __assign({ left: "xsmall" }, { children: [_jsx(Inset, __assign({ hideOnBreakpointUp: "medium", horizontal: "medium" }, { children: _jsx(Title, __assign({ as: "p", weight: "regular" }, { children: translate('headerTitle') })) })), _jsx(SubTitle, { children: usersLimit &&
                                    Number(usersLimit) > 0 &&
                                    translate('headerSubTitle', { usersLimit: usersLimit }) })] }))] }) })) })));
};
export default ManageCardholdersHeader;
